import { Route } from '@angular/router';

import { Type } from '@angular/core';
import { CompanyIndustriesViewComponent } from './company-industries/company-industries-view.component';
import { IndustriesComponent } from './industries.component';

export const ROUTING_COMPONENTS: Type<unknown>[] = [IndustriesComponent, CompanyIndustriesViewComponent];

export const industriesRoute: Route[] = [
  {
    path: '',
    component: IndustriesComponent,
    children: [
      {
        path: '',
        component: CompanyIndustriesViewComponent
      }
    ]
  }
];
